module.exports = __webpack_public_path__ + "static/media/RP-21.1478001d.pdf";